// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6eea0de8","687":"6eaa40c7","874":"c607e0a8"}[chunkId] + ".chunk.js";
};